
import { namespace } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'
import Tick from '~/components/Icons/Tick.vue'
import PriceTag from '~/components/Icons/PriceTag.vue'
import * as sq from '~/store/modules/sq'
import * as catalog from '~/store/modules/catalog'
import PlanInfoProvider from '~/lib/PlanInfoProvider'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

const SQ = namespace(sq.name)
const Catalog = namespace(catalog.name)

@Component({
  name: 'PlanCardSpeed',
  components: {
    Tick,
    PriceTag,
    VueSlickCarousel: () => import('vue-slick-carousel')
  },
  data() {
    return {
      infoProvider: PlanInfoProvider,
      year: new Date().getFullYear(),
      siteId: process.env.siteId,
      brand: process.env.brand,
      informationSummaries: process.env.informationSummaries,
      carouselKey: 0
    }
  },
  watch: {
    filteredPlans(value) {
      this.carouselKey = value
    }
  },
  props: {
    pagePromo: Object,
    minSpeed: Number,
    maxSpeed: Number
  },
  methods: {
    getFirstRangeMax(template) {
      if (template === 'template-speed-nbn') {
        return 50
      }
      if (template === 'template-switch-velo') {
        return 25
      }
      if (template === 'template-speed-velo') {
        return 1000
      }
      return 1000
    },
    getPlanDiscount(discounts, tier, up): number {
      if (discounts.includes('TEN-OFF') || discounts.includes('TEN-OFF-ALL') || discounts.includes('10-OFF-6MO')) {
        return 10
      }
      if (discounts.includes('30-OFF')) {
        return 30
      }
      if (discounts.includes('20-OFF-6MO')) {
        return 20
      }
      if (discounts.includes('SPEED-UPGRADE')) {
        if (discounts.includes('SPEED-UPGRADE-EOF')) {
          if (tier <= 100) {
          return 20
          }
          if (tier > 100) {
            return 30
          }
        }
        
        if (tier <= 100) {
          return 10
        }
        if (tier > 100) {
          return 30
        }
      }
      if (discounts.includes('SPEED-2024')) {
        if (tier === 25 || ( tier === 100 && up === 40) || tier === 250 || tier === 1000) {
          return 10
        }
        if (tier === 50) {
          return 14
        }
        if (tier === 100 && up === 20) {
          return 16
        }
      }
      if (discounts.includes('EOFY-2024')) {
        if ( tier === 100 && up === 40) {
          return 4
        }
        if (tier === 250 || tier === 1000) {
          return 10
        }
        if (tier === 100 && up === 20) {
          return 6
        }
      }
      if (discounts.includes('10-20-30')) {
        if (tier <= 100) {
          return 10
        }
        if (tier === 250) {
          return 20
        }
        if (tier === 1000) {
          return 30
        }
      }
      if (discounts.includes('10-14-16-6MO')) { 
        if (tier === 25 || ( tier === 50 && up === 20) || ( tier === 250 && up === 25) || ( tier === 1000 && up === 50)) {
          return 10
        }
        if ( tier === 100 && up === 20) {
          return 14
        }
        if (tier === 100 && up === 40) {
          return 16
        } 
      }
      if (discounts.includes('20-OFF-50') && tier === 50) {
        return 20;
      }
      return 0
    },
    formatPlanName(plan, template = null): string {
      const pn = plan.toString().split(' ')
      let formattedPlanName = ''
      let i
      // eslint-disable-next-line no-plusplus
      for (i = 0; i < pn.length; i++) {
        if (i === 1 && pn.length <= 3) formattedPlanName += `<strong>`
        if (i === 2 && pn.length > 3) formattedPlanName += `<br /><strong>`
        formattedPlanName += `${pn[i]} `
        if (i === pn.length - 1) formattedPlanName += `</strong>`
      }

      if (template && template === 'template-switch-velo' && pn.includes('50')) {
        formattedPlanName += '*'
      }
      return formattedPlanName
    },
    formatPrice(price): string {
      const pr = price.toString().split('.')
      let formattedPrice = '$'
      let i
      // eslint-disable-next-line no-plusplus
      for (i = 0; i < pr.length; i++) {
        if (i === 1 && pr.length <= 3) {
          formattedPrice += `.<span class="text-3xl">`
        }

        formattedPrice += `${pr[i]}`
        if (i === pr.length) formattedPrice += `</span>`
      }
      return formattedPrice
    },
    formatSkyPlan(name): string {
      const nm = name.split(' ')
      let formattedPlanName = name
      let i
      if (nm.length === 6) {
        formattedPlanName = ''
        // eslint-disable-next-line no-plusplus
        for (i = 0; i < nm.length; i++) {
          if (i === 1 && nm.length <= 3) formattedPlanName += ''
          if (i === 3 && nm.length > 4) formattedPlanName += `<br />`
          formattedPlanName += `${nm[i]} `
          if (i === nm.length - 1) formattedPlanName += ''
        }
      }
      return formattedPlanName
    }
  }
})
export default class PlanCardSpeed extends Vue {
  @SQ.Getter
  primaryNetwork

  @Catalog.Getter
  filteredPlans
  
  mobileSettings = [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: true,
      focusOnSelect: false
    }
  }, {
    breakpoint: 600,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
      focusOnSelect: false
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      focusOnSelect: false
    }
  }
  ]

  currentRoute() {
    return this.$router.currentRoute.name
  }
  
}
